import getDoorPosition from 'components/configurator/services/getDoorPosition';
import getDoorsFromWallParts from 'components/configurator/services/getDoorsFromWallParts';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';
import validGlassProperties from 'services/constants/validGlassProperties';

import IValidationError from '../IValidationError';

const getPreviousDoorPositionError = (
  door: IGlassWallDoor,
  previousDoor: IGlassWallDoor | null,
  wall: IWall
) => {
  if (previousDoor === null) {
    return null;
  }

  const previousDoorPosition = getDoorPosition(previousDoor, wall);
  const doorPosition = getDoorPosition(door, wall);

  if (previousDoorPosition.glass.left > doorPosition.glass.left) {
    return {
      message: "Door's insert position is smaller than the previous door's",
      property: 'insertPosition',
    };
  }

  if (previousDoorPosition.profile.right > doorPosition.profile.left) {
    return {
      message: 'Door overlaps with the previous door',
      property: 'insertPosition',
    };
  }

  const minGlassWall = validGlassProperties.length.min;
  const minStartingPosition = previousDoorPosition.profile.right + minGlassWall;
  if (minStartingPosition > doorPosition.profile.left) {
    return {
      message: `Glass between current and previous door can't be less than ${minGlassWall}mm`,
      property: 'insertPosition',
    };
  }

  return null;
};

const getDoorNameError = (door: IGlassWallDoor, wall: IWall) => {
  if (door.doorID === '') {
    return {
      message: 'Door name should not be empty',
      property: 'areaName',
    };
  }

  const wallDoors = getDoorsFromWallParts(wall);
  for (const otherDoor of wallDoors) {
    if (otherDoor.id === door.id) {
      continue;
    }

    if (otherDoor.doorID === door.doorID) {
      return {
        message: `Door name "${door.doorID}" is not unique in wall`,
        property: 'areaName',
      };
    }
  }

  return null;
};

const validateDoor = (
  door: IGlassWallDoor,
  previousDoor: IGlassWallDoor | null,
  wall: IWall
): IValidationError[] => {
  const validationErrors = [];

  const previousDoorPositionError = getPreviousDoorPositionError(
    door,
    previousDoor,
    wall
  );

  if (previousDoorPositionError !== null) {
    validationErrors.push(previousDoorPositionError);
  }

  const doorNameError = getDoorNameError(door, wall);
  if (doorNameError !== null) {
    validationErrors.push(doorNameError);
  }

  if (door.woodyDoorFrameDepth < 75 || door.woodyDoorFrameDepth > 215) {
    validationErrors.push({
      message: 'Woody door frame depth should be in between 75 mm and 215 mm',
      property: 'woodyDoorFrameDepth',
    });
  }

  return validationErrors;
};

export default validateDoor;
